import { render } from "./Homework.vue?vue&type=template&id=7c52e003&scoped=true&ts=true"
import script from "./Homework.vue?vue&type=script&lang=ts"
export * from "./Homework.vue?vue&type=script&lang=ts"

import "./Homework.vue?vue&type=style&index=0&id=7c52e003&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c52e003"]])

export default __exports__